import React, { useState, useEffect, ReactNode, useRef } from 'react'
import { Button, Checkbox, Chip, useTheme } from '@mui/material';
import ClipLoader from "react-spinners/ClipLoader";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from "@mui/material/IconButton";
import ApiFailed from '../../Utils/ApiFailed';
import { withStyles, createStyles } from '@mui/styles';
import { DataGrid, Column, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, Format, Export, HeaderFilter, Selection } from 'devextreme-react/data-grid';
import TextField from '@mui/material/TextField';
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import GoogleMapComponent from '../../components/Map/NewGoogleMaps2024';
import CHF from "assets/CHF.png";
import CHF1P from "assets/CHF1P.png";
import CHF2P from "assets/CHF2P.png";
import ZL from "assets/ZoneLog_Logger.png"
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ToolkitCHR from '../../components/Configuration/ToolkitCHR';
import ToolkitTOR from '../../components/Configuration/ToolkitTOR';
import yellowMarker from '../../assets/mapLocationMarkers/pinYellow.png';
import redMarker from '../../assets/mapLocationMarkers/pinRed.png';
import { isLCLLogger } from 'variables/chariotProductIds';
import CloseIcon from '@mui/icons-material/Close';
import { Redirect } from "react-router-dom";
import { Accordion, Item, AccordionTypes } from 'devextreme-react/accordion';
import MultiLoggerGraphV2 from "../Groups/MultiLoggerGraphV2";
import MultiLoggerGraph from '../Groups/MultiLoggerGraph';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { APIGetLoggerReadingsModel } from "models/APIGetLoggerReadingsModel";
import moment from 'moment'
import { GutermannModelConverter } from "../../Utils/GutermannModelCoverter";
import SiteModal from './NewSiteModal2024'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import ImagesPanel from 'components/ImageUpload/ImagesPanel'
import UploadDialog from "../../components/ImageUpload/UploadDialog"
import Comments from '../../components/Comments/Comments';
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import MinimumNightFlow from '../../components/MinimumNightFlow/MinimumNightFlow';
import { CheckBox } from '@mui/icons-material';
import Loader from '../../Utils/Loader/NewLoader2025'
import { Boundary, Coordinates } from '../../components/Site Functions/LoadSiteData';
import { APIImageUpload, buildAPIImageUpload } from "models/APIImageUpload";
import {
    reloadData,
    GPS,
    BoundaryStyling,
    defaultCenter,
    Company,
    RedirectProps,
    SiteLogger,
    Site
} from '../../components/Site Functions/LoadSiteDetailsData'
import ImageCopyModal from '../../components/ImageUpload/ImageCopyModal'



interface Props {
    classes: {
        root: string;
        heading: string;
        cardTitleWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            siteId: number;
            siteName: string;
        };
        search: string;
    };

}









interface BoundaryData {
    path: Array<Coordinates>
    styling: BoundaryStyling
}

interface ReadingsState {
    state: {
        loading: boolean;
        readingsData: Array<APIGetLoggerReadingsModel>;
    };
}










//const styles: Record<string, any> = {
//    formControl: {
//        minWidth: 120,
//    },
//    cardCategoryWhite: {
//        "&,& a,& a:hover,& a:focus": {
//            color: "rgba(255,255,255,.62)",
//            margin: "0",
//            fontSize: "14px",
//            marginTop: "0",
//            marginBottom: "0"
//        },
//        "& a,& a:hover,& a:focus": {
//            color: "#FFFFFF"
//        }
//    },
//    cardTitleWhite: {
//        position: 'absolute',
//        top: '50%',
//        transform: 'translateY(-50%)',
//        color: "#FFFFFF",
//        minHeight: "auto",
//        fontWeight: "300",
//        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
//        textDecoration: "none",
//        "& small": {
//            color: "#777",
//            fontSize: "65%",
//            fontWeight: "400",
//            lineHeight: "1"
//        }
//    }
//};

const style = createStyles(styles);
const SiteDetail: React.FC<Props> = ({ history, location, classes }) => {
    const intl:IntlShape = useIntl()
    const channelMLGReadings:ReadingsState = useRef(null)
    const containerStyle = {
        height: "620px",
        width: "100%",
        marginLeft: "5px",
        minHeight: "500px",
    };



    const mapRef = useRef(null);
    const [site, setSite] = useState<Site>()
    const [loading, setLoading] = useState<boolean>(false)
    const [tableHidden, setTableHidden] = useState<boolean>(false)
    const [loggerData, setLoggerData] = useState<Array<SiteLogger>>([])
    const [historicLoggerData, setHistoricLoggerData] = useState<Array<APILoggerDetail>>([])
    const [mapKey, setMapKey] = useState<string>("")
    const [center, setCenter] = useState<Coordinates>(defaultCenter)
    const [markers, setMarkers] = useState<Array<GPS>>([])
    const [hasBoundary, setHasBoundary] = useState<boolean>(false)
    const [polygonPath, setPolygonPath] = useState([]);
    const [boundaryStyling, setBoundaryStyle] = useState<BoundaryStyling>(
        {
            strokeWeight: 2,
            strokeColor: '#FF0000',
            areaColor: '#FF0000',
            transparency: 35
        })
    const [hoveredMarker, setHoveredMarker] = useState(null)
    const [chariotModal, setChariotModal] = useState(false)
    const [torModal, setTorModal] = useState(false)
    const [tempDevice, setTempDevice] = useState<Array<APILoggerDetail>>([])
    const [authorized, setAuthorized] = useState<boolean>(true)
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps>({
        siteName: "",
        siteId: null,
        serial: "",
        deviceId: null
    })
    const [loggerIds, setLoggerIds] = useState([])
    const [modal, setModal] = useState(false)
    const [loggersToBeAssigned, setLoggersToBeAssigned] = useState([])
    const [loggersToBeUnassigned, setLoggersToBeUnassigned] = useState<Array>([])
    const [companies, setCompanies] = useState<Array<Company>>([])
    const [lastDataDate, setLastDataDate] = useState<Date | null>()
    const [uploadDialogOpen, setUploadDialogOpen] = useState<boolean>(false)

    const [loggersToGraph, setLoggersToGraph] = useState<Array<APILoggerDetail>>([])
    ///dates

    const [startDate, setStartDate] = useState<Date>(moment(lastDataDate).subtract(8, 'days').toDate())
    const [endDate, setEndDate] = useState<Date>(moment(lastDataDate).toDate())
    const [showLinkDate, setShowLinkDate] = useState<boolean>(false)
    const [openDropDowns, setOpenDropDowns] = useState<Array<string>>([])
    const [linkDates, setLinkDates] = useState<boolean>(false)
    const [selectedItemIndex, setSelectedItemIndex] = useState<number>()
    const [imageMoveModal, setImageMoveModal] = useState<boolean>(false)
    const [numImages, setNumImages] = useState<number>()
    const [imageData, setImageData] = useState<APIImageUpload[]>([])
    const [imageURLs, setImageURLs] = useState<string[]>([])
    const [copyModal, setCopyModal] = useState<boolean>(false)
    const [imageDataCopy, setImageDataCopy] = useState<APIImageUpload[]>([])
    const [imageURLsCopy, setImageURLsCopy] = useState<string[]>([])

    useEffect(() => {
        reloadData(setLoading,
            location.state?.siteId,
            setPolygonPath,
            setSite,
            setLoggerData,
            setBoundaryStyle,
            setHasBoundary,
            setMarkers,
            setLoggersToBeAssigned,
            setAuthorized,
            startDate,
            setLastDataDate,
            setHistoricLoggerData,
            setLoggerIds)
            getImages(null)
    }, [])



        
    
    
    

    

    const renderConfigBtn = (data): ReactNode => {
        
        return <Button variant="contained" onClick={(): void => handleConfigClick(data)}><FormattedMessage id="Configure" /></Button>
    }

    const renderOverviewBtn = (data): ReactNode => {
        return <Button variant="contained" color="secondary" onClick={(): void => onMarkerClick(data.data.serial) }><FormattedMessage id="Overview" /></Button>
    }

    const handleConfigClick = (data): void => {
        setTempDevice(data.data)
        if (isLCLLogger(data.data.model)) {
            toggleChariotModal()
        } else {
            toggleTorModal()
        }
    }


    const onMapLoad = (map) => {
        mapRef.current = map;
        map.setMapTypeId("hybrid")
        fitBoundsToMarkers(); // Fit bounds after the map loads

        if (!hasBoundary && markers.length === 1) {
            setTimeout(() => {
                mapRef.current.setZoom(18)
            }, 500)
        }
    };

    const onPolygonClick = () => {
        /* do nothing */
    }

    const updatePolygonPath = () => {
        /*do nothing in this component */
    }


    const onMarkerClick = (serial: number): void => {
        
        const clickedMarker = loggerData.filter(logger => logger.serial === serial)
        setRedirect(true)
        setRedirectPath(!isLCLLogger(clickedMarker[0].model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        setRedirectProps({
            serial: serial,
            mapKey: 'test'
        })
    }

    const handleTooltipShow = (serial: number): void => {

        setHoveredMarker(serial)
    }

    const handleTooltipHide = (): void => {
        setHoveredMarker(null)
    }

    const fitBoundsToMarkers = () => {

        if (mapRef.current && markers.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            markers.forEach((marker) => {
                bounds.extend(marker.position);
            });
            if (hasBoundary) {
                polygonPath.forEach((corner) => {
                    bounds.extend(corner)
                })
            }
            mapRef.current.fitBounds(bounds);
        } else if (mapRef.current && polygonPath.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            polygonPath.forEach((corner) => {
                bounds.extend(corner)
            })
            mapRef.current.fitBounds(bounds);
        }
    };

    const toggleChariotModal = () => {
        setChariotModal(!chariotModal)
    }

    const toggleTorModal = () => {
        setTorModal(!torModal)
    }


    const blankFunction = () => {
        return undefined;
    };

    const renderModelCol = (data):ReactNode => {

        if (window.location.hostname.includes('zonelog.net')) {
            return (<p style={{ marginTop: "7px" }}>{GutermannModelConverter(data.data.model)}</p>)
        } else {
            return (<p style={{ marginTop: "7px" }}>{data.data.model}</p>)
        }
    }

    const renderLastConnection = (data): ReactNode => {

        return (<p style = {{ marginTop: "7px" } }>{formatDate(data.data.lastConnection)}</p>)
    }
    const renderDeployDate = (data):ReactNode => {
        return (<p style={{ marginTop: "7px" }}>{formatDate(data.data.deploymentDate)}</p>)
    }

    const formatDate = (date):string => {
        return moment(date).format('DD MMM YYYY HH:mm')
    }

    const toggleEditModal = (): void => {
        CallGetAPI(CreateUrl(`/api/aquaguard/GetCompanyAndChildren?companyGUID=${sessionStorage.getItem('companyGuid')}`), {})
            .then(companyData => {
                const companiesTemp = [...companies]
                companyData.forEach(company => companiesTemp.push({ name: company.name, id: company.id, isParent: company.parentId ? false : true }))
                companiesTemp.sort(function (x, y) {
                    return Number(y.isParent) - Number(x.isParent)
                })
                setCompanies(companiesTemp)
            })
                
        setModal(!modal)
    }

    const handleTextFieldChange = (name: string, value: string): void => {

        const siteTemp = { ...site }
        siteTemp[name] = value
        setSite(siteTemp)
    }

    const handleLoggersToBeUnassigned = (logger) => {
        const loggersToBeUnassignedTemp = [...loggersToBeUnassigned, logger]
        const siteTemp = site
        if (siteTemp.loggers.length > 1) {
            siteTemp.loggers = siteTemp.loggers.filter(siteLogger => siteLogger.serial !== logger.serial)
        } else {
            siteTemp.loggers = []
        }
        setSite(siteTemp)
        setLoggersToBeUnassigned(loggersToBeUnassignedTemp)
    }


    const handleSiteChange = (selected, assignDate, polygonPath, boundaryStyling, hasBoundary, tempName): void => { 
        let boundaryInfo = null
        if (Array.isArray(polygonPath) && polygonPath.length > 0) {
            boundaryInfo = JSON.stringify({ path: polygonPath, styling: boundaryStyling })
        }
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Id: site.siteId,
                    SiteName: tempName.siteRefTemp,
                    SiteNameUserFriendly: tempName.siteNameTemp,
                    Created: site.created,
                    Deleted: site.deleted,
                    Latitude: site.Latitude || 0,
                    Longitude: site.Longitude || 0,
                    FKCompanyId: site.fkCompanyId,
                    DefaultSite: false,
                    LastUpdate: site.lastUpdate,
                    FkEASiteId: null,
                    Boundary: hasBoundary ? boundaryInfo : null
                })
            };

            CallPutAPI(CreateUrl('/api/Aquaguard/Site/' + site.siteId), requestOptions)
                .then(data => {
                    createSuccessNotification()
                    if (selected.length > 0) {
                        const loggerIds: Array<{ Id: number }> = [];
                        selected.forEach(logger => loggerIds.push({ Id: logger.LoggerId }))
                        const requestOptions = {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                siteId: site.siteId,
                                lastUpdate: site.lastUpdate,
                                loggers: loggerIds,
                                assignLogReadingsFromDate: assignDate,
                                deploymentGuid: null
                            })
                        };

                        CallPostAPI(CreateUrl('/api/Aquaguard/AssignLoggersToSite'), requestOptions)
                            .then(data => {
                                setLoading(true)
                                createSuccessNotification()
                                setTimeout(() => reloadData(
                                    setLoading,
                                    location.state.siteId,
                                    setPolygonPath,
                                    setSite,
                                    setLoggerData,
                                    setBoundaryStyle,
                                    setHasBoundary,
                                    setMarkers,
                                    setLoggersToBeAssigned,
                                    setAuthorized,
                                    startDate,
                                    setLastDataDate,
                                    setHistoricLoggerData,
                                    setLoggerIds), 1000)
                            })
                            .catch(err => {
                                createErrorNotification()
                                console.log(err)
                            })
                    }
                    handleUnAssigningLoggersCall()
                    if (selected.length === 0 && loggersToBeUnassigned.length === 0) {

                        setTimeout(() => reloadData(
                            setLoading,
                            location.state.siteId,
                            setPolygonPath,
                            setSite,
                            setLoggerData,
                            setBoundaryStyle,
                            setHasBoundary,
                            setMarkers,
                            setLoggersToBeAssigned,
                            setAuthorized,
                            startDate,
                            setLastDataDate,
                            setHistoricLoggerData,
                            setLoggerIds), 1000)
                    }
                })
                .then(() => {
                    console.log('done')
                })
                .catch(err => {
                    createErrorNotification()
                    console.log(err)
                })

        


    }

    const handleUnAssigningLoggersCall = (): void => {

        if (loggersToBeUnassigned.length > 0) {
            const loggerIds: Array<{ Id: number }> = [];
            loggersToBeUnassigned.map((l) => {
                loggerIds.push({ Id: l.loggerId });
            });
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    loggers: loggerIds,
                    shutdown: false,
                    force: true
                })
            };
            CallPostAPI(CreateUrl('/api/Aquaguard/UndeployLoggers'), requestOptions)
                .then(data => {
                    createSuccessNotification()
                    setLoggersToBeUnassigned([])
                })
                .catch(err => {
                    createErrorNotification()
                    setLoggersToBeUnassigned([])
                    console.log(err)
                })
                setLoading(true)
            setTimeout(() => reloadData(
                setLoading,
                location.state.siteId,
                setPolygonPath,
                setSite,
                setLoggerData,
                setBoundaryStyle,
                setHasBoundary,
                setMarkers,
                setLoggersToBeAssigned,
                setAuthorized,
                startDate,
                setLastDataDate,
                setHistoricLoggerData,
                setLoggerIds), 1000)
        }

    } 

    const handleUploadButtonClick = ():void => {
        setUploadDialogOpen(!uploadDialogOpen)
    }

    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }))

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Contact Administrator' }), 5000, () => {
            alert('callback');
        });
    };

    const renderSerialTemplate = ({ data }): React.ReactNode => {
        const theme = useTheme()
        return <Chip
            style={{marginTop: "3px"} }
            label={data.serial}
            sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
            onClick={():void => onMarkerClick(data.serial) }
        />
    }

    const gridMarginRender = ({ data }, name): React.ReactNode => {

        return <p style={{marginTop: "7px"} }>{data[name]}</p>
    }

    const renderOutputCheckBox = ({ data }): React.ReactNode => {

        return <Checkbox checked={data.isSiteOutput} color="primary" onClick={():void => handleCheckBoxClick(data) } />
    }


    const handleCheckBoxClick = (data) => {
        setLoading(true)
        const yes = confirm('Are you sure you want to change this Device?')
        if (yes) {
            CallPutAPI(CreateUrl(`/api/Aquaguard/SetOutputDevice?serial=${data.serial}&value=${!data.isSiteOutput}`), {})
                .then(data => {
                    setTimeout(() => reloadData(
                        setLoading,
                        location.state.siteId,
                        setPolygonPath,
                        setSite,
                        setLoggerData,
                        setBoundaryStyle,
                        setHasBoundary,
                        setMarkers,
                        setLoggersToBeAssigned,
                        setAuthorized,
                        startDate,
                        setLastDataDate,
                        setHistoricLoggerData,
                        setLoggerIds), 500)
                    createSuccessNotification()

                })
                .catch(err => {
                    createErrorNotification()
                    console.error(err)
                    setLoading(false)
                })
        } else return
    }

    const handleDateUpdate = (startDateProps: Date, endDateProps: Date): void => {


        const loggerIdsTemp = loggerIds
        historicLoggerData.forEach(log => {

            /// check if loggerId is already in for the date range and needs to be removed
            if (loggerIds.includes(log.loggerId) && !loggerData.map(l => l.loggerId).includes(log.loggerId)) {
                if (moment(log.endDate).isBefore(moment(startDateProps))) {
                    const removeIndex = loggerIdsTemp.indexOf(log.loggerId)
                    loggerIdsTemp.splice(removeIndex, 1)
                }
            }
            if (!loggerIds.includes(log.loggerId) && log.endDate && moment(log.endDate).isAfter(moment(startDateProps))) {
                loggerIdsTemp.push(log.loggerId)
            }

        })
        if (loggerIdsTemp.length === 1) {
            sessionStorage.setItem('selectedLoggers', loggerIdsTemp[0].toString())
        } else if (loggerIdsTemp.length > 1) {

            sessionStorage.setItem('selectedLoggers', loggerIdsTemp.map(logger => logger.toString()).join())
        } else {
            sessionStorage.setItem('selectedLoggers', "")
        }
        setLoggerIds(loggerIdsTemp)
        setStartDate(startDateProps)
        setEndDate(endDateProps)
    }

    const handleDropDownOpen = (e: AccordionTypes.SelectionChangedEvent):void => {
        let openDropDownsTemp: Array<number>
        if (e.addedItems.length > 0) {

            openDropDownsTemp = [...openDropDowns, e.addedItems[0].title]

        }
        if (e.removedItems.length > 0) {
            openDropDownsTemp = openDropDowns.filter(d => d !== e.removedItems[0].title)
        }

        if (openDropDownsTemp.includes('Graph') && openDropDownsTemp.includes('Minimum Night Flow')) {

            setShowLinkDate(true)
        } else {
            setShowLinkDate(false)
        }
        setOpenDropDowns(openDropDownsTemp)
    }


    const getImages = (id: number | undefined | null): void => {
        let useAzure = false
        const imageDataTemp = new Array<APIImageUpload>();
        const imageURLDataTemp = new Array<string>();
        let imageCount = 0;
        CallGetAPI(CreateUrl('/api/image/Images?siteId=' + location.state.siteId
            + "&loggerId=" + 0
            + "&chariotId=" + 0
        ), {})
            .then(data => {
            for (let i = 0; i < data.length; i++) {
                if (data[0].id.toString() == "00000000-0000-0000-0000-000000000000") {
                    useAzure = true;
                }
                if (useAzure == true) {
                    imageDataTemp.push(buildAPIImageUpload(data[i], null));
                    imageURLDataTemp.push(data[i].filename);
                    imageCount++;
                }
                else {
                    imageDataTemp.push(buildAPIImageUpload(data[i], null));
                    imageURLDataTemp.push(CreateUrl('/api/image/Images/' + data[i].id.toString()));
                    imageCount++;
                }

            }
            console.log(imageURLDataTemp)
            setTimeout(() => {
                    setNumImages(imageCount)
                    setImageData(imageDataTemp)
                    setImageURLs(imageURLDataTemp)
                    //originalImageData: data
            }, 1000)
        })
            .catch(err => {
                console.error(err)
            })
    }

    const toggleCopyModal = (): void => {
        if (copyModal) {
            getImages(null)
        } else {
            
            const promises = new Array<Promise<any>>();
            for (let i = 0; i < loggerData.length; i++) {
                if (loggerData[i].loggerId > 500000) {
                    promises.push(
                        CallGetAPI(CreateUrl('/api/image/Images?siteId=' + 0
                            + "&loggerId=" + 0
                            + "&chariotId=" + (loggerData[i].loggerId - 500000)
                        ), {})
                    )
                } else {
                    promises.push(

                        CallGetAPI(CreateUrl('/api/image/Images?siteId=' + 0
                            + "&loggerId=" + loggerData[i].loggerId
                            + "&chariotId=" + 0
                        ), {})
                    )
                }


            }
            Promise.all(promises).then(allImages => {
                let useAzure = false
                const imageArrayData: APIImageUpload[] = []
                const innerArrayURLs: string[] = []
                allImages.forEach(innerArr => {
                    if (innerArr.length > 0) {
                        for (let i = 0; i < innerArr.length; i++) {
                            if (innerArr[0].id.toString() == "00000000-0000-0000-0000-000000000000") {
                                useAzure = true
                            }
                            if (useAzure == true) {
                                if (!imageURLs.includes(innerArr[i].filename)) {
                                    imageArrayData.push(buildAPIImageUpload(innerArr[i], null));
                                    innerArrayURLs.push(innerArr[i].filename);
                                }
                            }
                            else {
                                const url = CreateUrl('/api/image/Images/' + innerArr[i].id.toString())
                                if (!imageURLs.includes(url)) {
                                    imageArrayData.push(buildAPIImageUpload(innerArr[i], null));
                                    innerArrayURLs.push(url);
                                }
                            }
                        }
                    }
                })
                setImageDataCopy(imageArrayData)
                setImageURLsCopy(innerArrayURLs)
            }) 
        }
        setCopyModal(!copyModal)
    }

    


    return (
        <>
            {authorized ? ( !redirect ? <div>
                {loading &&
                    <div style={{
                        position: 'absolute', left: 'Calc(50% - 100px)', top: 'Calc(50% - 100px)',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 13000
                    }}>
                        <Loader color={undefined} />
                    </div>
                }
                {!loading && <div>
                    {tableHidden &&
                        <ApiFailed />
                    }
                    {!tableHidden &&
                        <div>
                            
                            {site?.siteName && <SiteModal
                                open={modal}
                                modalTitle={`${intl.formatMessage({ id: 'Edit Site -' })} ${site?.siteNameUserFriendly ? site?.siteNameUserFriendly : ""}`}
                                onCancel={toggleEditModal}
                                site={site}
                                handleTextFieldChange={handleTextFieldChange}
                                unAssignedLoggers={loggersToBeAssigned}
                                editSite={true}
                                handleLoggersToBeUnassigned={handleLoggersToBeUnassigned}
                                onSubmit={handleSiteChange}
                                companies={companies }
                            />}
                            <ImageCopyModal
                                show={copyModal}
                                loggerId={null}
                                lcLoggerId={null}
                                siteId={location.state?.siteId}
                                parent="lcLogger"
                                images={imageDataCopy}
                                imageURLs={imageURLsCopy}
                                toggleCopyModal={toggleCopyModal}
                                serials={loggerData.map(log => {
                                    return {serial: log.serial, id: log.loggerId}
                                })}
                            />
                            <Dialog
                                fullScreen
                                open={chariotModal}
                            >
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={(): void => toggleChariotModal()}
                                            aria-label="close"
                                        >
                                            <ArrowBackIcon style={{ fill: "black" }} />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                            {window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "ZONELOG Configuration" }) : intl.formatMessage({ id: "Chariot Configuration" })}
                                        </Typography>
                                    </Toolbar>
                                </AppBar>
                                {tempDevice &&
                                    <ToolkitCHR
                                        serial={tempDevice?.serial}
                                        product={tempDevice?.model}
                                        model={tempDevice?.modelId}
                                        channels={tempDevice?.channelsAvail}
                                        meterConfig={tempDevice?.meterConfig}
                                    />
                                }
                            </Dialog>
                            <Dialog
                                fullScreen
                                open={torModal}
                            >
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={(): void => toggleTorModal()}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                            {tempDevice?.model} {intl.formatMessage({ id: 'Configuration' })}
                                        </Typography>
                                    </Toolbar>
                                </AppBar>
                                {tempDevice &&
                                    <ToolkitTOR
                                        serial={tempDevice?.serial}
                                        product={tempDevice?.model}
                                        model={tempDevice?.modelId}
                                    />
                                }
                            </Dialog>
                            
                            <UploadDialog
                                show={uploadDialogOpen}
                                title={intl.formatMessage({ id: "Upload Image" })}
                                siteId={location.state?.siteId}
                                loggerId={0}
                                onSubmit={(): void => {
                                    setUploadDialogOpen(false)
                                    setTimeout(() => getImages(), 1000)

                                }}
                                onCancel={(): void => setUploadDialogOpen(false)}
                            />
                            <GridContainer >
                                <GridItem xs={12} sm={12} md={12}>
                                    <Card>
                                        <CardHeader color="primary" className="view view-cascade  d-flex justify-content-between align-items-center py-2 mx-4 mb-3">
                                            <div style={{ display: 'inline' }}>
                                                <IconButton
                                                    style={{ display: 'inline' }}
                                                    onClick={(): void => history.goBack()}
                                                    size="large"><ArrowBackIcon style={{ fill: "white" }} /></IconButton>
                                                <h4 style={{ display: 'inline' }} className={classes.cardTitleWhite}>{location.state?.siteName}</h4>
                                                
                                            </div>
                                            <Button style={{ marginRight: "10px" }} onClick={(): void => { toggleEditModal()}} variant="contained"><FormattedMessage id="Edit Site" /></Button>
                                        </CardHeader>
                                        <CardBody>
                                            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", marginBottom: "30px" }}>
                                                <div style={{ width: "60%", margin: "0 10px 0 0"}}>
                                                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                        <h4><FormattedMessage id="Active Devices At Site" /></h4>
                                                        <DataGrid
                                                            dataSource={loggerData}
                                                            allowColumnResizing={true}
                                                            allowColumnReordering={true}
                                                        >
                                                            <Column dataField="serial" dataType="number" cellRender={renderSerialTemplate} caption={intl.formatMessage({ id: "Serial" })} />
                                                            <Column dataField="deviceName" dataType="string" caption={intl.formatMessage({ id: 'Device Name' })} cellRender={(data):React.ReactNode => gridMarginRender(data, 'deviceName')} />
                                                            <Column dataField="model" cellRender={renderModelCol} caption={intl.formatMessage({ id: "Model" })} />
                                                            <Column dataField="lastConnection" cellRender={renderLastConnection} caption={intl.formatMessage({id: 'Last Connection'}) } />
                                                            <Column dataField="deploymentDate" cellRender={renderDeployDate} caption={intl.formatMessage({ id: "Assigned To Site" })} />
                                                            <Column dataField="latitude" dataType="number" caption={intl.formatMessage({ id: 'Latitude' })} cellRender={(data): React.ReactNode => gridMarginRender(data, 'latitude')} />
                                                            <Column dataField="longitude" dataType="number" caption={intl.formatMessage({ id: 'Longitude' })} cellRender={(data): React.ReactNode => gridMarginRender(data, 'longitude')} />
                                                            <Column dataField="isSiteOutput" dataType="boolean" caption={"Site Output"} width={90} cellRender={renderOutputCheckBox} />
                                                            <Column cellRender={renderConfigBtn} caption={intl.formatMessage({ id: "Configure" })} width={123} />
                                                            <Column cellRender={renderOverviewBtn} caption={intl.formatMessage({ id: "Overview" })} width={110} />
                                                        </DataGrid>
                                                    </div>
                                                    {historicLoggerData.length > 0 && <div style={{marginTop: "10px"} }>
                                                        <h4><FormattedMessage id="Historic Devices At Site" /></h4>
                                                        <DataGrid
                                                            dataSource={historicLoggerData}
                                                            keyExpr="id"
                                                        >
                                                            <StateStoring enabled={true} type="localStorage" storageKey="historyListGrid" />
                                                            <FilterRow visible={true} />
                                                            <Column dataField="id" visible={false} dataType="number" />
                                                            <Column dataField="serial" dataType="string" sortOrder={'asc'} caption={intl.formatMessage({ id: "Serial" })} />
                                                            <Column dataField="siteId" dataType="string" caption={intl.formatMessage({ id: 'Device Name' })} />
                                                            <Column dataField="startDate" dataType="datetime" caption={intl.formatMessage({id: 'Start Date'}) } />
                                                            <Column dataField="endDate" dataType="datetime" caption={intl.formatMessage({ id: 'End Date' })} />
                                                            <Pager allowedPageSizes={[10, 20, 50]} showPageSizeSelector={true} />
                                                            <Paging defaultPageSize={10} />
                                                        </DataGrid>
                                                    </div>}
                                                </div>
                                                <div style={{ width: "40%", margin: "0 0 20px 10px" }}>
                                                {(markers.length > 0 || polygonPath.length > 0) && <GoogleMapComponent
                                                        mapKey={mapKey}
                                                        containerStyle={containerStyle}
                                                        center={center}
                                                        onMapLoad={onMapLoad}
                                                        markers={markers}
                                                        hasBoundary={hasBoundary}
                                                        createBoundary={false}
                                                        polygonPath={polygonPath}
                                                        boundaryStyling={boundaryStyling}
                                                        onPolygonClick={onPolygonClick}
                                                        updatePolygonPath={updatePolygonPath}
                                                        handleMouseOverMarker={handleTooltipShow}
                                                        handleMouseOutMarker={handleTooltipHide}
                                                        onMarkerClick={onMarkerClick}
                                                        hoveredMarker={hoveredMarker}
                                                        editBoundary={false}
                                                        showTooltip={true}
                                                    />}
                                                </div>
                                            </div>

                                            {(loggerData.length > 0 || historicLoggerData.length > 0) && <Accordion
                                                collapsible={true}
                                                multiple={true}
                                                onSelectionChanged={(e) => handleDropDownOpen(e)}
                                                defaultSelectedIndex={-1}
                                                

                                            >
                                                <Item title={intl.formatMessage({ id: "Graph" })} >
                                                    <div>
                                                        {loggerData.length > 0 ?
                                                            <MultiLoggerGraphV2 showDates={true} location={{ state: { groupId: 0, loggers: loggerIds, showBackButton: false, site: null, combinedFlowSiteId: location.state.siteId } }} history={{ goBack: blankFunction }} fullscreen={false} handleDateUpdate={(startDate, endDate): void => handleDateUpdate(startDate, endDate)} />:
                                                            <MultiLoggerGraphV2 endDateProps={endDate} startDateProps={startDate} showDates={true} location={{ state: { groupId: 0, loggers: [], showBackButton: false, site: location.state.siteId, combinedFlowSiteId: location.state.siteId } }} history={{ goBack: blankFunction }} fullscreen={false} handleDateUpdate={(startDateProps, endDateProps): void => handleDateUpdate(startDateProps, endDateProps)} />}
                                                    </div>
                                                </Item>
                                                {loggerData.length > 0 && <Item title={intl.formatMessage({ id: "Minimum Night Flow" })}>
                                                    <div>
                                                        <MinimumNightFlow siteId={location.state.siteId} serial={null} loggerData={loggerData} startDateProps={startDate} endDateProps={endDate} showDateLink={showLinkDate} />
                                                    </div>
                                                </Item>}
                                                <Item title={intl.formatMessage({ id: "Comments" })} >
                                                    <Comments lcLoggerId={null} loggerId={null} siteId={location.state.siteId} />
                                                </Item>
                                                <Item title={intl.formatMessage({ id: "Images" })} >
                                                    <div>
                                                        <Button
                                                            variant="contained"
                                                            onClick={(): void => handleUploadButtonClick()}
                                                        >
                                                            <FormattedMessage id="Upload" />
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            onClick={(): void => toggleCopyModal()}
                                                            color="secondary"
                                                            style={{marginLeft: 10} }
                                                        >
                                                        <FormattedMessage id="Copy Images From Devices" />
                                                        </Button>
                                                        
                                                        <ImagesPanel
                                                            siteId={location.state.siteId}
                                                            loggerId={0}
                                                            chariotId={0}
                                                            imageURLs={imageURLs}
                                                            imageData={imageData}
                                                            numImages={numImages}
                                                            getImages={() =>getImages()}
                                                        />
                                                        
                                                    </div>
                                                </Item>
                                            </Accordion>}
                                        </CardBody>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </div>
                    }

                </div>}
            </div> : <Redirect push to={{
                pathname: redirectPath,
                state: redirectProps
            }} />) :
            <Redirect to={'/Login'} />} 
        </>
        )
}
export default withStyles(style)(SiteDetail);